import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeroSection from "../components/HeroSection";
import Marquee from "../components/Marquee";
import ServicesSection from "../components/ServicesSection";
import WhyChooseUs from "../components/WhyChooseUs";
import ProcessSection from "../components/ProcessSection";
import FeaturedWork from "../components/FeaturedWork";
import IndustriesStrip from "../components/IndustriesStrip";
import LeadForm from "../components/LeadForm";
import Testimonials from "../components/Testimonials";
import FooterCTA from "../components/FooterCTA";
import useDocumentMeta from "../lib/useDocumentMeta";

const HomePage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useDocumentMeta({
        title: "Graphic Designer in Nagpur | Raj Graphics — Branding, Printing & Signage",
        description:
            "Raj Graphics is a graphic design, branding and printing studio in Nagpur. Logo design, packaging, signage, brochures and websites for growing businesses. Get a quote today.",
        canonical: "/",
    });

    useEffect(() => {
        if (location.hash) {
            const el = document.querySelector(location.hash);
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
            }
        }
    }, [location.hash]);

    const scrollToId = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <main data-testid="home-page">
            <HeroSection
                onCtaWork={() => scrollToId("work")}
            />
            <Marquee />
            <ServicesSection
                onItemClick={() => navigate("/services")}
            />
            <WhyChooseUs />
            <ProcessSection />
            <FeaturedWork limit={5} />
            <IndustriesStrip />
            <LeadForm />
            <Testimonials />
            <FooterCTA />
        </main>
    );
};

export default HomePage;
